import { getUserToken } from './getUserToken';
import { isValidUserToken } from './isValidUserToken';

export function hasValidUserToken(): boolean {
  const token = getUserToken();
  const isTokenValid = isValidUserToken(token);

  return isTokenValid;
}
